
import React from 'react';
import { OrderingDoctorEditModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { OrderingDoctorEditModalViewStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new OrderingDoctorEditModalViewStore(rootStore, componentProps), 'orderingDoctorEditModalViewStore')
@observer
class OrderingDoctorEditModal extends React.Component {
    render() {
        return <OrderingDoctorEditModalTemplate {...this.props} />
    }
}

export default OrderingDoctorEditModal;
